import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', function() {

	// Responsive slider
	const responsiveSlider = document.querySelector('.responsive-slider--wrapper');
	if (responsiveSlider) {
		const slider = new Flickity(responsiveSlider, {
			cellAlign: 'left',
			contain: true,
			wrapAround: true,
			prevNextButtons: true,
			pageDots: false
		});

		window.addEventListener('resize', function() {
			slider.resize();
		});
	}

	// Team slider
	const teamSlider = document.querySelector('.team-slider--wrapper');
	if (teamSlider) {
		const slider = new Flickity(teamSlider, {
			cellAlign: 'left',
			contain: true,
			wrapAround: true,
			prevNextButtons: true,
			pageDots: false,
			draggable: false
		});

		window.addEventListener('resize', function() {
			slider.resize();
		});
	}

	// Featured projects slider
	const featuredProjectsSliders = document.querySelectorAll('.featured-projects--slider');
	if (featuredProjectsSliders.length > 0) {
		// Initialize width calculations for each slider
		featuredProjectsSliders.forEach(function(sliderElement) {
			const winWidth = window.innerWidth;
			const offset = winWidth > 991 ? 60 : 40;
			const group = sliderElement.closest('.wp-block-group');
			const width = group.offsetWidth;
			sliderElement.classList.add('is-spanning');
			sliderElement.style.width = (width - offset) + 'px';
		});

		const slider = new Flickity('.featured-projects--slider', {
			cellAlign: 'left',
			wrapAround: true,
			prevNextButtons: true,
			pageDots: false,
			draggable: false
		});

		window.addEventListener('resize', function() {
			// Recalculate widths on resize
			featuredProjectsSliders.forEach(function(sliderElement) {
				const winWidth = window.innerWidth;
				const offset = winWidth > 991 ? 60 : 40;
				const group = sliderElement.closest('.wp-block-group');
				const width = group.offsetWidth;
				sliderElement.classList.add('is-spanning');
				sliderElement.style.width = (width - offset) + 'px';
			});
			
			slider.resize();
		});
	}

	// Icon slider
	const iconSliders = document.querySelectorAll('.icon-slider');
	if (iconSliders.length > 0) {
		// Initialize width calculations for each slider
		iconSliders.forEach(function(sliderElement) {
			const winWidth = window.innerWidth;
			const offset = winWidth > 991 ? 60 : 40;
			const group = sliderElement.closest('.wp-block-group');
			const width = group.offsetWidth;
			sliderElement.classList.add('is-spanning');
			sliderElement.style.width = (width - offset) + 'px';
		});

		const slider = new Flickity('.icon-slider', {
			cellAlign: 'left',
			wrapAround: true,
			prevNextButtons: true,
			pageDots: false,
			draggable: false
		});

		window.addEventListener('resize', function() {
			// Recalculate widths on resize
			iconSliders.forEach(function(sliderElement) {
				const winWidth = window.innerWidth;
				const offset = winWidth > 991 ? 60 : 40;
				const group = sliderElement.closest('.wp-block-group');
				const width = group.offsetWidth;
				sliderElement.classList.add('is-spanning');
				sliderElement.style.width = (width - offset) + 'px';
			});

			slider.resize();
		});
	}

});
